<template>
  <div>
    <v-dialog v-model="pointSettingDialog" max-width="705">
      <v-card
        class="overflow-y-auto overflow-x-auto membership_point_search_setting_width"
      >
        <v-card-title class="pt-5 pl-5 pb-3"
          >멤버십 적립금 지급 설정</v-card-title
        >

        <v-card-text class="pl-5">
          <p class="mb-0">
            멤버십 회원등급에 지급하는 적립금 설정이 가능합니다.
          </p>
        </v-card-text>

        <div class="d-flex">
          <v-select
            outlined
            single-line
            hide-details
            class="pl-5 pr-2 mb-2"
            v-model="pointTypeModel"
            :items="pointTypeItems"
            @change="pointTypeChange()"
            style="max-width:230px;"
            dense
          ></v-select>

          <div v-if="pointTypeModel === 0" class="d-flex align-center">
            <v-text-field
              v-model="point"
              outlined
              single-line
              hide-details
              style="max-width:100px;"
              class="pr-2 mb-2"
              dense
              @keydown="M.replaceCommaNumber($event, 8, true)"
              @keyup="M.replaceCommaNumber($event, 8, true)"
            ></v-text-field>
            <p class="mb-2">원 지급</p>
          </div>
          <div v-if="pointTypeModel === 1" class="d-flex align-center">
            <v-select
              outlined
              single-line
              hide-details
              v-model="dayModel"
              :items="dayItems"
              style="max-width:100px;"
              class="pr-2 mb-2"
              dense
              disabled
            ></v-select>
            <v-text-field
              v-model="point"
              outlined
              single-line
              hide-details
              style="max-width:100px;"
              class="pr-2 mb-2"
              dense
              @keydown="M.replaceCommaNumber($event, 8, true)"
              @keyup="M.replaceCommaNumber($event, 8, true)"
            ></v-text-field>
            <p class="mb-2 mr-5">원 지급</p>
          </div>
        </div>

        <v-btn
          color="grey lighten-2"
          hide-details
          depressed
          class="ml-5 mt-5 mb-5"
          @click="pointSettingDialog = false"
          width="320"
          >닫기</v-btn
        >

        <v-btn
          color="primary"
          hide-details
          class="white--text ml-2 mt-5 mb-5 pl-4 pr-4 mr-5"
          depressed
          @click="pointSave()"
          width="337"
          >설정</v-btn
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import Common from "@/libs/common.js";

export default {
  data: () => {
    return {
      M,
      pointSettingDialog: false,
      pointTypeModel: 0,
      pointTypeItems: [
        { text: "멤버십 구매시", value: 0 },
        { text: "다음달", value: 1 },
      ],

      dayModel: "01",
      dayItems: [
        { text: "01일", value: "01" },
        { text: "02일", value: "02" },
        { text: "03일", value: "03" },
        { text: "04일", value: "04" },
        { text: "05일", value: "05" },
        { text: "06일", value: "06" },
        { text: "07일", value: "07" },
        { text: "08일", value: "08" },
        { text: "09일", value: "09" },
        { text: "10일", value: "10" },
        { text: "11일", value: "11" },
        { text: "12일", value: "12" },
        { text: "13일", value: "13" },
        { text: "14일", value: "14" },
        { text: "15일", value: "15" },
        { text: "16일", value: "16" },
        { text: "17일", value: "17" },
        { text: "18일", value: "18" },
        { text: "19일", value: "19" },
        { text: "20일", value: "20" },
        { text: "21일", value: "21" },
        { text: "22일", value: "22" },
        { text: "23일", value: "23" },
        { text: "24일", value: "24" },
        { text: "25일", value: "25" },
        { text: "26일", value: "26" },
        { text: "27일", value: "27" },
        { text: "28일", value: "28" },
        { text: "29일", value: "29" },
        { text: "30일", value: "30" },
        { text: "31일", value: "31" },
      ],
      point: 0,
    };
  },
  methods: {
    show: function() {
      this.pointSettingDialog = true;
      this.reset();
    },
    pointChange: function() {
      //console.log(this.pointModal);
    },
    pointTypeChange: function() {
      //console.log(this.pointTypeModal);
    },
    pointSave: function() {
      let point_issued_type = "";
      let point_subscription = "";

      if (this.pointTypeModel == 0) {
        point_issued_type = "payment";
      } else {
        point_issued_type = "subscription";
        point_subscription = `${this.dayModel} 00:00`;
      }
      if (this.point == 0) {
        alert("포인트를 입력해주세요.");
        return false;
      }
      let setData = {
        point_issued_type: point_issued_type,
        point_subscription: point_subscription,
        point: Common.onlyNumber(this.point),
      };

      this.$parent.addPointList(setData);
      alert("설정 되었습니다.");
      this.pointSettingDialog = false;
    },

    reset: function() {
      this.pointTypeModel = 0;
      this.dayModel = "01";
      this.point = 0;
    },
  },
};
</script>
